import { TextField, IconButton, Typography, Box, InputAdornment } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import CancelIcon from '@mui/icons-material/Cancel'
import { tokens } from '../../../theme'

const statusColors = {
  default: { border: '#e0e0e0', text: '#858585' },
  error: { border: tokens.colors.error, text: tokens.colors.error },
  success: { border: tokens.colors.primary.main, text: tokens.colors.primary.main },
  warning: { border: tokens.colors.warning, text: tokens.colors.warning },
}

export function Input({
  label,
  placeholder = '',
  value,
  onChange,
  helperText,
  showInfo = false,
  onInfoClick,
  type = 'text',
  status = 'default',
  statusMessage,
  onClear,
  disabled = false,
}) {
  const colors = statusColors[status]
  const showClearButton = value.length > 0 && onClear
  const displayHelperText = statusMessage || helperText

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.25,
          mb: 0.5,
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontFamily: tokens.typography.fontFamily.input,
            fontWeight: 600,
            fontSize: 14,
            color: tokens.colors.gray[900],
            letterSpacing: '-0.28px',
          }}
        >
          {label}
        </Typography>
        {showInfo && (
          <InfoOutlinedIcon
            onClick={onInfoClick}
            sx={{
              fontSize: 16,
              color: tokens.colors.primary.main,
              cursor: onInfoClick ? 'pointer' : 'default',
            }}
          />
        )}
      </Box>
      <TextField
        fullWidth
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        variant="outlined"
        slotProps={{
          input: {
            endAdornment: showClearButton ? (
              <InputAdornment position="end">
                <IconButton onClick={onClear} edge="end" size="small" sx={{ color: '#858585' }}>
                  <CancelIcon sx={{ fontSize: 20 }} />
                </IconButton>
              </InputAdornment>
            ) : null,
          },
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            bgcolor: status === 'default' ? tokens.colors.primary[100] : '#fff',
            fontFamily: tokens.typography.fontFamily.input,
            fontSize: 14,
            '& fieldset': {
              borderColor: status === 'default' ? 'transparent' : colors.border,
              borderWidth: status !== 'default' ? 1 : 0,
            },
            '&:hover fieldset': {
              borderColor: status === 'default' ? tokens.colors.primary[100] : colors.border,
              borderWidth: 1,
            },
            '&.Mui-focused fieldset': {
              borderColor: tokens.colors.primary.main,
              borderWidth: 2,
            },
          },
          '& .MuiInputBase-input': {
            color: tokens.colors.gray[900],
            padding: '12px',
            '&::placeholder': {
              color: '#C2C2C2',
              opacity: 1,
            },
          },
        }}
      />

      {displayHelperText && (
        <Typography
          sx={{
            fontFamily: tokens.typography.fontFamily.input,
            fontSize: 12,
            color: colors.text,
            mt: 0.5,
            lineHeight: 1.5,
          }}
        >
          {displayHelperText}
        </Typography>
      )}
    </Box>
  )
}
